import { tagLabelKey } from '../classify';
import { CHIP } from '../describe/ui';
import { useT } from '../i18n/useT';

/** Small market-tag label on a card (#875): the market's most specific tag ("Champions League", "BTC"). */
export default function TagLabel({ tag }: { tag: string }) {
  const t = useT();
  return (
    <span className={`${CHIP} rounded bg-surface-2 px-1.5 text-fg/80`} data-testid="tag-label" data-tag={tag}>
      {t(tagLabelKey(tag))}
    </span>
  );
}
